import { TilesProps } from '@common/types';
import { useOutdatedBrowserSnapshot } from '@hooks/security';
import { DoughnutChartTile } from '@pages/InsightsAndAnalytics/tiles/DoughnutChartTile';
import { useEffect, useState } from 'react';

type Params = {
  days: string;
  groupList?: string[];
  browserType?: string;
  accountType?: string;
  locationList?: string[];
};

export const OutdatedBrowserSnapshot: React.FC<TilesProps> = ({
  params,
  classNames,
}) => {
  const [parameters, setParameters] = useState<Params>(JSON.parse(params));
  const { data, isLoading, refetch } = useOutdatedBrowserSnapshot(
    parameters
  );

  useEffect(() => {
    setParameters(JSON.parse(params));

    return () => {
      refetch();
    };
  }, [params, refetch]);

  const browserCount = data?.snapshot ? Object.values(data.snapshot) : [];
  const browserNames = data?.snapshot ? Object.keys(data.snapshot) : [];

  return (
    <DoughnutChartTile
      classNames={classNames ? classNames : 'col-span-3 lg:col-auto'}
      contextData={[]}
      sortData={[]}
      headerTitle={'Outdated browsers used'}
      dropdownMenuItemClasses={'!w-[300px]'}
      isLoading={isLoading}
      data={browserCount}
      dataLabels={browserNames}
      buttonLabel={''}
      showMessageIfEmpty={false}
    />
  );
};
